export default "__VITE_ASSET__DCfFXmv___"